import { useEffect } from 'react';
import { Location, NavigationType, useLocation, useNavigationType } from 'react-router-dom';

export namespace History {
    const urls: string[] = [];

    export function push(url: string) {
        urls.push(url);
    }

    export function pop() {
        urls.pop();
    }

    export function getLast(): string {
        return urls[urls.length - 1];
    }

    export function getPreviousUrls(): string[] {
        return urls;
    }
}

export const useLocationListener = () => {
    const location: Location = useLocation();
    const navType: NavigationType = useNavigationType();

    useEffect(() => {
        if (navType === 'POP') {
            History.pop();
        }
        if (navType === 'PUSH' && location.pathname !== History.getLast()) {
            History.push(location.pathname);
        }
        if (navType === 'REPLACE') {
            History.pop();
            History.push(location.pathname);
        }
    }, [location, navType]);
};
